import {
  RadiusID,
  RentalPriceID,
  SurfaceMinimumID,
} from '@kamernet/core/ApiClient/Kamernet';

import { IListingsState } from '@kamernet/modules/Listing/context/ListingsContext';
import {
  RadiusIDLabels,
  RentalPriceIDLabels,
  SurfaceMinimumIDLabels,
} from '@kamernet/modules/Listing/messages';

export function getSearchAlertSetEventPayload(listingsState: IListingsState) {
  return {
    citysearch: listingsState.filterResult.filters.location?.cityName,
    radius:
      RadiusIDLabels[
        listingsState.filterResult.filters.radiusId ?? RadiusID.Km10
      ],
    'max price':
      RentalPriceIDLabels[
        listingsState.filterResult.filters.maxRentalPriceId ??
          RentalPriceID.Eur0
      ],
    'min surface':
      SurfaceMinimumIDLabels[
        listingsState.filterResult.filters.surfaceMinimumId ??
          SurfaceMinimumID.M6
      ],
    filterCount: listingsState.filterResult.count,
  };
}
